import moment from 'moment';
import { useCallback, useState } from 'react';
import Calendar from 'react-calendar';
import { useDispatch } from 'react-redux';
import { Calender } from './styles';
import { getRawComment, getUTCDate } from '../../helpers/common';
import { COMMENT_TYPE } from '../../global/constants';
import { trackAnalyticActivity } from '../../services/analyticsService';
import { DataCommentsInterface, RawUpdateCommentInterface } from '../../interfaces/TaskInterface';
import { createNewComment, updateRecurringTaskDetails, updateTaskDetails } from '../../services/taskServices';
import { TASK_ANALYTICS } from '../../global/analyticsConstants';
import SVGIcon from '../../assets/images/svg/SVGIcon';
import { TaskModel } from '../../mobx/models/task';
import { rootStore } from '../../mobx/rootStore';
import { observer } from 'mobx-react-lite';
import { nanoid } from 'nanoid';

interface CalendarProps {
  date?: Date;
  setCalendarDate?: (date: Date) => void;
  taskData?: TaskModel;
  isUpdateReducer?: boolean;
  loadData?: () => void;
  isShareDocModel?: boolean;
  setLinkDate?: (value: any) => void;
  isRecurringTask?: boolean;
  isInbox?: boolean;
  closeDropdowns?: () => void;
}
const CalendarComponentV2 = (props: CalendarProps) => {
  const {
    date,
    isUpdateReducer,
    taskData,
    loadData,
    setCalendarDate,
    isShareDocModel,
    setLinkDate,
    isRecurringTask,
    isInbox,
    closeDropdowns
  } = props;
  //State
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  //Mobx store variables
  const { currentUser, workspaceStore } = rootStore;
  const { currentWorkspace: workspace } = workspaceStore;
  const workspace_id = workspace?.id;
  //other variable
  const dispatch = useDispatch();

  const onClickDate = useCallback(
    async (date: Date) => {
      closeDropdowns?.();
      const updatedDate = moment(date).utc().format();
      setSelectedDate(date);
      setCalendarDate?.(date);
      let dueDate;
      if (!isShareDocModel) {
        if (isUpdateReducer) {
          dueDate = updatedDate;
          rootStore.taskStore.createTaskInput.setDueDate(new Date(dueDate!));
        } else if (isInbox) {
          return;
        } else {
          if (moment(date).toISOString() !== moment(props?.taskData?.dueDate).toISOString()) {
            dueDate = updatedDate;
            const payload = {
              ...taskData,
              companyId: workspace_id,
              previousDueDate: taskData?.dueDate,
              dueDate: dueDate
            };
            if (payload?.createdBy) {
              delete payload?.createdBy;
            }
            const payloadTask = { dueDate: payload?.dueDate, projectId: payload?.projectId };
            if (isRecurringTask) {
              const response = await dispatch(updateRecurringTaskDetails(payload?.id, payloadTask));
              if (response) {
                if (!payload?.previousDueDate) trackAnalyticActivity(TASK_ANALYTICS.SCHEDULED);
                else trackAnalyticActivity(TASK_ANALYTICS.RESCHEDULED);
                loadData?.();
              }
            } else {
              if (!currentUser) return;
              const newComment: RawUpdateCommentInterface = {
                id: nanoid(),
                type: taskData?.dueDate ? COMMENT_TYPE.CHANGE_DUE_DATE : COMMENT_TYPE.SET_DUE_DATE,
                previousDueDate: taskData?.dueDate?.toISOString() || '',
                dueDate: payload?.dueDate
              };
              const updatedComment = getRawComment(newComment, currentUser);

              taskData?.setDueDate(new Date(payload?.dueDate));
              taskData?.upsertComment(updatedComment);
              const response = await dispatch(updateTaskDetails(payload?.id, payloadTask));
              const commentPayload: DataCommentsInterface = {
                Type: COMMENT_TYPE.SET_DUE_DATE,
                PreviousDueDate: newComment?.previousDueDate,
                DueDate: payload?.dueDate
              };
              if (payload?.previousDueDate) {
                commentPayload['Type'] = COMMENT_TYPE.CHANGE_DUE_DATE;
                commentPayload['PreviousDueDate'] = new Date(payload?.previousDueDate).toISOString();
              }
              const commentResult = await dispatch(createNewComment(payload?.id, commentPayload));
              if (response && commentResult) {
                if (!payload?.previousDueDate) trackAnalyticActivity(TASK_ANALYTICS.SCHEDULED);
                else trackAnalyticActivity(TASK_ANALYTICS.RESCHEDULED);
              }
            }
          }
        }
      } else {
        setLinkDate?.(getUTCDate(moment(updatedDate)).toISOString());
      }
    },
    [
      closeDropdowns,
      setCalendarDate,
      isShareDocModel,
      isUpdateReducer,
      isInbox,
      props?.taskData?.dueDate,
      taskData,
      workspace_id,
      isRecurringTask,
      dispatch,
      loadData,
      currentUser,
      setLinkDate
    ]
  );

  return (
    <Calender onClick={(e) => e.stopPropagation()}>
      <Calendar
        onClickDay={onClickDate}
        value={selectedDate || date}
        prev2Label={<SVGIcon name='calender-prev2Label' width='14' height='14' viewBox='0 0 16 16' />}
        prevLabel={<SVGIcon name='calender-prevLabel' width='14' height='14' viewBox='0 0 16 16' />}
        next2Label={<SVGIcon name='calender-next2Label' width='14' height='14' viewBox='0 0 16 16' />}
        nextLabel={<SVGIcon name='calender-nextLabel' width='14' height='14' viewBox='0 0 16 16' />}
      />
    </Calender>
  );
};

export default observer(CalendarComponentV2);
